import ItemsTable from "./ItemsTable";

export default ItemsTable;
